import { logging as clientLogging } from 'epc-logger/client-logging';
import {
    getTiming, getPerformanceNavigationRedirectCount, getLanguageId,
    getPerformanceNavigationType, getTimingCalculations
} from './LoggerUtil';

let initialLoadTTI = null;
let viewNavStartTime = null;

function logTTI() {
    let ttiValue;
    let ttiValueNoRedirect;
    let params = [
        'clEventName01=timeToInteraction',
        'clEventName02=timeToInteractionNoRedirect'
    ];

    if (Number.isNaN(viewNavStartTime)) {
        params.push('timeToInteractionNoPageLoadStartTime=true');
        params.push('timeToInteraction=0');
        params.push('clEventTime01=0');
    } else {
        const renderTime = new Date().getTime();
        let loadStartTime;
        let loadStartTimeNoRedirect;

        if (initialLoadTTI) {
            loadStartTime = viewNavStartTime;
            loadStartTimeNoRedirect = viewNavStartTime;
        } else {
            loadStartTime = Number.isNaN(getTiming('navigationStart')) ? getTiming('fetchStart') : getTiming('navigationStart');
            loadStartTimeNoRedirect = getTiming('fetchStart');
        }

        ttiValue = renderTime - loadStartTime;
        ttiValueNoRedirect = renderTime - loadStartTimeNoRedirect;

        params.push(`languageId=${getLanguageId()}`);
        params.push(`navigationType=${getPerformanceNavigationType(initialLoadTTI)}`);
        params.push(`navigationRedirectCount=${getPerformanceNavigationRedirectCount(initialLoadTTI)}`);
        params.push(`timeToInteractionNoRedirect=${ttiValueNoRedirect}`);
        params.push(`timeToInteraction=${ttiValue}`);
        params.push(`clEventTime01=${ttiValue}`);
        params.push(`clEventTime02=${ttiValueNoRedirect}`);
        params.push(`pageLoadStartTime=${loadStartTime}`);
        params.push(`pageLoadStartTimeNoRedirect=${loadStartTimeNoRedirect}`);

        params = getTimingCalculations(initialLoadTTI, viewNavStartTime, params);
    }

    clientLogging.logTrxEvent('timeToInteraction', params);

    return ttiValue;
}

function setAnalyticsPageName(viewName) {
    clientLogging.setPageName(`eg-partner-onboarding-qualifier.${viewName}`);
}

function viewTTIstart() {
    viewNavStartTime = new Date().getTime();
}

function viewTTIstop() {
    if (initialLoadTTI) {
        logTTI();
    } else {
        if (window && window.performance && window.performance.timing) {
            viewNavStartTime = window.performance.timing.navigationStart;
        }
        initialLoadTTI = logTTI();
    }
}

export {
    viewTTIstart, viewTTIstop, setAnalyticsPageName
};
